// Curated industry verticals for the Account "Industry" field (CRM batch
// 2026-07-24). Free-text-with-suggestions: reps can type anything, but these
// ~25 promo-relevant verticals populate the <datalist> and the list-page
// filter so the values stay consistent enough to search across ("pull all
// Property Management accounts for a targeted product push").
export const INDUSTRY_SUGGESTIONS = [
  "Property Management",
  "Real Estate",
  "Healthcare",
  "Hospitals & Health Systems",
  "Senior Living",
  "Construction",
  "Technology / Software",
  "Financial Services",
  "Banking & Credit Unions",
  "Insurance",
  "Law Firms",
  "Education (K-12)",
  "Higher Education",
  "Nonprofit",
  "Hospitality & Hotels",
  "Restaurants & Food Service",
  "Retail",
  "Manufacturing",
  "Logistics & Transportation",
  "Automotive",
  "Sports & Fitness",
  "Events & Entertainment",
  "Government & Municipal",
  "Staffing & HR",
  "Marketing Agencies",
] as const;

/** Pure: the suggestions plus every industry already typed on an account
 *  (Stephanie 2026-10-16: "no option to add a new industry"), once each —
 *  case and spacing ignored, first spelling kept — sorted A–Z. */
export function industryOptions(used: ReadonlyArray<string | null | undefined>): string[] {
  const seen = new Map<string, string>();
  for (const v of [...INDUSTRY_SUGGESTIONS, ...used]) {
    const t = (v ?? "").trim().replace(/\s+/g, " ");
    if (!t) continue;
    const key = t.toLowerCase();
    if (!seen.has(key)) seen.set(key, t);
  }
  return [...seen.values()].sort((a, b) => a.localeCompare(b));
}
